export default __webpack_public_path__ + "static/media/close.3d942651.svg";